import React, { useState, useEffect } from "react";
import axios from "axios";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { OMS_URL } from "utils/constants";
import { Flex } from "ui-components";
import Spinner, { styles } from "components/Spinner";
import "./styles.css";
// https://docs.adyen.com/checkout/web-sdk/

const loadDropin = props => {
  const { paymentRequestData = {}, onSuccess, onFail, returnUrl } = props;
  const verifyPath = paymentRequestData.verify_path;
  const action_object = paymentRequestData.action_object;
  const configuration = {
    paymentMethodsResponse: {
      paymentMethods: get(action_object, "payment_methods")
    },
    originKey: paymentRequestData.origin,
    locale: paymentRequestData.locale, //"en-US",
    environment: paymentRequestData.env, //"test",
    paymentMethodsConfiguration: {
      card: {
        // Example optional configuration for Cards
        hasHolderName: false,
        holderNameRequired: false,
        enableStoreDetails: false,
        hideCVC: false, // Change this to true to hide the CVC field for stored cards
        name: "Credit/Debit card"
      }
    }
  };
  try {
    const checkout = new window.AdyenCheckout(configuration);
    checkout
      .create("dropin", {
        amount: {
          value: action_object.amount,
          currency: action_object.currency
        },
        onSubmit: (state, dropin) => {
          console.log(state);
          const orderRef = paymentRequestData.order_ref;
          let payload = { data: state };
          payload.order_ref = orderRef;
          dropin.setStatus("loading");
          axios
            .post(`${OMS_URL}${verifyPath}`, payload)
            .then(data => {
              const result = get(data, "data.result") || {};
              let returnPath;
              if (returnUrl) {
                returnPath = returnUrl;
              } else if (result.return_url) {
                returnPath = result.return_url;
              } else if (result.deeplink) {
                returnPath = result.deeplink;
              }
              if (!isEmpty(result)) {
                dropin.setStatus("success");
                onSuccess(result, returnPath);
              } else {
                dropin.setStatus("error");
                onFail(result, returnPath);
              }
            })
            .catch(err => {
              if (onFail) {
                dropin.setStatus("error");
                onFail(err);
              }
            });
        },
        onAdditionalDetails: (state, dropin) => {
          console.log(
            "Future use case => handle the onAdditionalDetails process request"
          );
        }
      })
      .mount("#payment");
    return checkout;
  } catch (error) {
    console.log("Error while loadDropin ", error);
  }
};

const AdyenDropin = props => {
  const [dropinLoaded, setDropinLoaded] = useState(false);

  useEffect(() => {
    const { paymentRequestData = {}, loading } = props;

    if (!loading && !isEmpty(paymentRequestData) && !dropinLoaded) {
      const init = setInterval(() => {
        if (isFunction(window.AdyenCheckout)) {
          clearInterval(init);
          const dropin = loadDropin(props);
          if (!isEmpty(dropin)) {
            setDropinLoaded(true);
          }
        }
      }, 1000);
    }
  }, [props, dropinLoaded]);

  return (
    <Flex
      className={!dropinLoaded ? "loading" : ""}
      id="payment"
      alignItems={"center"}
      justifyContent={"center"}
    >
      {!dropinLoaded && <Spinner sx={styles.modalContainer} />}
    </Flex>
  );
};

export default AdyenDropin;
